<div class="send-page-content">
  <!-- L1 Assets Container -->
  @if (!isL2Network()) {
    <app-l1-send-assets-container
      (kaspaClick)="onKaspaCardClick()"
      (krc20Click)="onKrc20CardClick()"
      (nftClick)="onNftCardClick()"
      (knsClick)="onKnsCardClick()"
    />
  }

  <!-- L2 Assets Container -->
  @if (isL2Network()) {
    <app-l2-send-assets-container
      (kaspaClick)="onL2KaspaCardClick()"
      (erc20Click)="onL2Erc20CardClick()"
    />
  }
</div>
